import React from "react";
import TimelineTodo from "components/TodoList/TimelineTodo/TimelineTodo";

export default ({ todoLists, total }) => {
  const noList = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };

  return (
    <div className="to-do-list">
      {todoLists.map((todolist, index) => (
        <TimelineTodo key={todolist.id} todoList={todolist} index={index} />
      ))}
      {total === 0 && <div style={noList}>You don't have any Todo Lists</div>}
    </div>
  );
};
